import React, { useState } from 'react';
import './RegistrationModal.css';

const RegistrationModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitToAmoCRM = async (formData) => {
    try {
      const form = document.createElement('form');
      form.action = 'https://forms.amocrm.ru/queue/add';
      form.method = 'POST';
      form.target = 'amocrm_hidden_frame';
      form.style.display = 'none';

      let iframe = document.getElementById('amocrm_hidden_frame');
      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.id = 'amocrm_hidden_frame';
        iframe.name = 'amocrm_hidden_frame';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      }

      // Generate UUID fallback
      const generateUUID = () => {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
          return crypto.randomUUID();
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = (Math.random() * 16) | 0;
          const v = c === 'x' ? r : ((r & 0x3) | 0x8);
          return v.toString(16);
        });
      };

      const fields = [
        { name: 'fields[name_1]', value: formData.name },
        { name: 'fields[1441295_1][1457693]', value: formData.phone },
        { name: 'fields[note_2]', value: '' },
        { name: 'form_id', value: '1555774' },
        { name: 'hash', value: 'b9fd77c52e783d85666fec7466745269' },
        { name: 'user_origin', value: JSON.stringify({ datetime: new Date().toISOString(), referer: window.location.href }) },
        { name: 'visitor_uid', value: generateUUID() },
        { name: 'form_request_id', value: Math.random().toString(36).substring(2, 15) },
        { name: 'gso_session_uid', value: generateUUID() }
      ];

      fields.forEach(field => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = field.name;
        input.value = field.value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();

      setTimeout(() => {
        if (document.body.contains(form)) {
          document.body.removeChild(form);
        }
      }, 2000);

      return true;
    } catch (error) {
      console.error('AmoCRM error:', error);
      return false;
    }
  };

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = 'Ism familyangizni kiriting';
    } else if (formData.fullName.trim().length < 3) {
      newErrors.fullName = 'Ism familya kamida 3 ta belgidan iborat bo\'lishi kerak';
    }

    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = 'Telefon raqamingizni kiriting';
    } else if (!/^\+?[0-9]{9,15}$/.test(formData.phoneNumber.replace(/\s/g, ''))) {
      newErrors.phoneNumber = 'To\'g\'ri telefon raqamini kiriting';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setIsSubmitting(true);

      // Submit to AmoCRM
      const success = await submitToAmoCRM({
        name: formData.fullName,
        phone: formData.phoneNumber
      });

      setIsSubmitting(false);

      if (success) {
        // Call parent onSubmit for success dialog
        onSubmit(formData);

        // Reset form
        setFormData({
          fullName: '',
          phoneNumber: ''
        });
        setErrors({});
      } else {
        // Show error if AmoCRM failed
        alert('Xatolik yuz berdi. Iltimos qayta urinib ko\'ring.');
      }
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-container">
        <div className="modal-header">
          <h2 className="modal-title">Masterclassga ro'yxatdan o'tish</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form className="modal-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">
              Ism Familya <span className="required">*</span>
            </label>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              className={`form-input ${errors.fullName ? 'error' : ''}`}
              placeholder="Ismingiz va familyangizni kiriting"
            />
            {errors.fullName && <span className="error-message">{errors.fullName}</span>}
          </div>

          <div className="form-group">
            <label className="form-label">
              Telefon Raqam <span className="required">*</span>
            </label>
            <input
              type="tel"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              className={`form-input ${errors.phoneNumber ? 'error' : ''}`}
              placeholder="+998 90 123 45 67"
            />
            {errors.phoneNumber && <span className="error-message">{errors.phoneNumber}</span>}
          </div>

          <button type="submit" className="submit-button" disabled={isSubmitting}>
            <span>{isSubmitting ? 'Yuklanmoqda...' : 'Yuborish'}</span>
            {!isSubmitting && <span className="button-arrow">→</span>}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RegistrationModal;
